// Voortgang van de AI-interviewer op de vragenlijstpagina.
//
// De pagina (QuestionnaireOpen) toont haar eindscherm zodra `fieldIndex`
// voorbij de laatste stap staat en haalt dan de interviewer van het scherm.
// Bij het laatste antwoord gebeurde dat midden in Decca's afscheid, en het
// datakanaal viel dicht zonder nette `session.close`. De interviewer houdt de
// voortgang daarom op de laatste vraag vast; pas als de backend `endInterview`
// aanroept en de sessie gesloten is, springt hij voorbij het einde.
// AI-CONTEXT: See docs/features/ai-interviewer-gpt-live.md

/** Voorbij elke stap: laat de pagina haar eindscherm tonen. */
export const END_OF_QUESTIONNAIRE_INDEX = Number.MAX_SAFE_INTEGER;

/**
 * @param {number} position - 1-gebaseerde positie van de zojuist opgeslagen vraag
 * @param {number} questionCount - Aantal vragen dat deze respondent gesteld krijgt
 * @returns {number} De fieldIndex om te tonen, nooit voorbij de laatste vraag
 */
export const heldFieldIndex = (position, questionCount) => (
    Math.max(0, Math.min(position, questionCount - 1))
);

export default heldFieldIndex;
